import React from 'react';
import { useState } from 'react';

function Contact() {
  // State untuk menangani nilai formulir
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  // Fungsi untuk menangani pengiriman formulir
  const handleSubmit = (e) => {
    e.preventDefault(); // Mencegah halaman reload saat mengirim formulir

    // Membuat pesan yang ingin dikirim ke WhatsApp dengan format yang rapi
    const whatsappMessage = `
      *Nama:* ${name}
      *Email:* ${email}
      *No. Whatsapp:* ${phone}
      *Subject:* ${subject}
      *Pesan:* ${message}
    `;

    // Menyiapkan URL WhatsApp dengan nomor penerima tetap (6285156811979) dan pesan yang sudah diformat
    const recipientPhone = '6281288596966'; // Nomor penerima
    const whatsappUrl = `https://wa.me/${recipientPhone}?text=${encodeURIComponent(whatsappMessage)}`;

    // Mengarahkan ke WhatsApp menggunakan window.open() untuk langsung membuka aplikasi
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Kontak Kami
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Beranda</a>
                  </li>
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    Kontak
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* Contact Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Kontak Kami
            </h6>
            <h1 className="mb-5" style={{ color: 'black' }}>
              Hubungi Kami Untuk Pertanyaan Apa Pun
            </h1>
          </div>
          <div className="row g-4">
            {/* Contact Info Section */}
            <div
              className="col-lg-6 col-md-12 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="card shadow-sm border-light rounded stabilo1">
                <div className="card-body">
                  <h5 style={{ color: 'black' }}>Punya Pertanyaan?</h5>
                  <p className="mb-4">
                    Sebagai wasilah perjalanan bagi para tamu Allah, kami siap
                    melayani dan membantu para tamu Allah dalam menunaikan
                    ibadah ke Baitullah. Jika ada pertanyaan mengenai paket
                    haji, umroh dan halal tour service, Anda dapat terhubung
                    dengan kami kapanpun.
                    <br />
                    #UmrohMudahAntiResah
                  </p>
                  {/* Contact Details */}
                  <div className="d-flex align-items-center mb-4">
                    <div
                      className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary"
                      style={{ width: 50, height: 50 }}
                    >
                      <i className="fa fa-map-marker-alt text-white" />
                    </div>
                    <div className="ms-3">
                      <h6 className="text-primary">Kantor Pusat</h6>
                      <p className="mb-0">
                        Jl. Jakarta No.12, Karangpawitan, Karawang Barat, Jawa
                        Barat, Indonesia, 41315
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <div
                      className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary"
                      style={{ width: 50, height: 50 }}
                    >
                      <i className="fa fa-envelope-open text-white" />
                    </div>
                    <div className="ms-3">
                      <h6 className="text-primary">Email</h6>
                      <p className="mb-0">sanematour@gmail.com</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <div
                      className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary"
                      style={{ width: 50, height: 50 }}
                    >
                      <i className="fa fa-clock text-white" />
                    </div>
                    <div className="ms-3">
                      <h6 className="text-primary">Jam Operasional</h6>
                      <p className="mb-0">Senin - Jumat 08.00 s/d 17.00 WIB</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <div
                      className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary"
                      style={{ width: 50, height: 50 }}
                    >
                      <i className="fa fa-clock text-white" />
                    </div>
                    <div className="ms-3">
                      <h6 className="text-primary">Jam Operasional</h6>
                      <p className="mb-0">Sabtu 09.00 s/d 13.00 WIB</p>
                    </div>
                  </div>

                  {/* Google Map Section - New Row */}
                  <div className="col-12 wow fadeInUp" data-wow-delay="0.7s">
                    <a
                      href="https://maps.google.com/?q=Sanema%20Tour"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-block" // Membuat <a> menjadi blok agar mencakup seluruh iframe
                    >
                      <div className="card shadow-sm border-light rounded">
                        <div className="card-body">
                          <iframe
                            className="position-relative rounded w-100"
                            frameBorder={0}
                            style={{ minHeight: 300, border: 0 }}
                            allowFullScreen=""
                            aria-hidden="false"
                            tabIndex={0}
                            src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Sanema%20Tour&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                          />
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form Section */}
            <div
              className="col-lg-6 col-md-12 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="card shadow-sm border-light rounded stabilo1">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            style={{ color: 'black' }}
                            id="name"
                            placeholder="Your Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                          <label htmlFor="name">Nama</label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="email"
                            className="form-control"
                            style={{ color: 'black' }}
                            id="email"
                            placeholder="Your Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <label htmlFor="email">Email</label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            style={{ color: 'black' }}
                            id="whatsapp"
                            placeholder="Whatsapp"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          />
                          <label htmlFor="whatsapp">No. Whatsapp</label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            style={{ color: 'black' }}
                            id="subject"
                            placeholder="Subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                          />
                          <label htmlFor="subject">Subject</label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-floating">
                          <textarea
                            className="form-control"
                            placeholder="Leave a message here"
                            id="message"
                            style={{ height: 100, color: 'black' }}
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                          />
                          <label htmlFor="message">
                            Tulis Pertanyaan/Pesan Anda Disini
                          </label>
                        </div>
                      </div>
                      <div className="col-12">
                        <button
                          className="btn btn-primary w-100 py-3"
                          type="submit"
                        >
                          Kirim Pesan
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="container-xxl py-5">
              <div className="container">
                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                  <h6 className="section-title bg-white text-center text-primary px-3">
                    Cabang Kami
                  </h6>
                  <h1 className="mb-5" style={{ color: 'black' }}>
                    Temukan Cabang Kami di Beberapa Lokasi
                  </h1>
                </div>
                <div className="row g-4">
                  {/* Cabang Bandung */}
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card shadow-sm border-light rounded stabilo1">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: 'black' }}>
                          Cabang Bandung
                        </h5>
                        <p className="card-text">
                          <i className="fa fa-map-marker-alt text-primary me-2" />
                          Jl. Maskumambang No. 23A Lengkong Tunggara Kota
                          Bandung Jawa Barat
                        </p>
                        <p className="card-text">
                          <i className="fa fa-phone-alt text-primary me-2" />
                          <a
                            href="https://wa.me/082143655529"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Chat ke Whatsapp (Customer Service)
                          </a>
                        </p>

                        {/* Google Map Image */}
                        <iframe
                          className="w-100"
                          height="200"
                          src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Jl.%20Maskumambang%20No.%2023A%20lengkong%20tunggara&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Cabang Depok*/}
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card shadow-sm border-light rounded stabilo1">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: 'black' }}>
                          Cabang Depok
                        </h5>
                        <p className="card-text">
                          <i className="fa fa-map-marker-alt text-primary me-2" />
                          Perumahan Villa Rizki Ilham 2 Cluster RA/3 Sawangan
                          Depok Jawa Barat
                        </p>
                        <p className="card-text">
                          <i className="fa fa-phone-alt text-primary me-2" />
                          <a
                            href="https://wa.me/082246614478"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Chat ke Whatsapp (Chairul Mustafa)
                          </a>
                        </p>
                        {/* Google Map Image */}
                        <iframe
                          className="w-100"
                          height="200"
                          src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Perumahan%20Villa%20Rizki%20Ilham%202%20Cluster%20RA%2F3%20Sawangan%20Depok%20Jawa%20Barat&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Cabang Bogor*/}
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card shadow-sm border-light rounded stabilo1">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: 'black' }}>
                          Cabang Bogor
                        </h5>
                        <p className="card-text">
                          <i className="fa fa-map-marker-alt text-primary me-2" />
                          Ruko Kirana Mas No. 1 Jl. Letda Natsir RT 03 RW 009,
                          DS. Bojong Kulur, Kec. Gunung Putri, Kab. Bogor
                        </p>
                        <p className="card-text">
                          <i className="fa fa-phone-alt text-primary me-2" />
                          <a
                            href="https://wa.me/0818817822"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Chat ke Whatsapp (H Syamsu)
                          </a>
                        </p>
                        {/* Google Map Image */}
                        <iframe
                          className="w-100"
                          height="200"
                          src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Ruko%20Kirana%20Mas%20No.%201%20Jl.%20Letda%20Natsir%20RT%2003%20RW%20009%2C%20DS.%20Bojong%20Kulur%2C%20Kec.%20Gunung%20Putri%2C%20Kab.%20Bogor&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Cabang Bekasi */}
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card shadow-sm border-light rounded stabilo1">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: 'black' }}>
                          Cabang Bekasi
                        </h5>
                        <p className="card-text">
                          <i className="fa fa-map-marker-alt text-primary me-2" />
                          Jl. Azalea Raya No.7 Acacia Lippo Cikarang, Cikarang
                          Pusat, Kabupaten Bekasi. Jawa Barat
                        </p>
                        <p className="card-text">
                          <i className="fa fa-phone-alt text-primary me-2" />
                          <a
                            href="https://wa.me/082298769000"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Chat ke Whatsapp (Agustina Nurul H)
                          </a>
                        </p>
                        {/* Google Map Image */}
                        <iframe
                          className="w-100"
                          height="200"
                          src="https://maps.google.com/maps?width=600&height=400&hl=en&q=jl.%20Azalea%20Raya%20No.7%20Acacia%20Lippo%20Cikarang%2C%20Cikarang%20Pusat&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Perwakilan Bekasi */}
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card shadow-sm border-light rounded stabilo1">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: 'black' }}>
                          Perwakilan Bekasi
                        </h5>
                        <p className="card-text">
                          <i className="fa fa-map-marker-alt text-primary me-2" />
                          Jl. Kaliabang Bungur RT. 04 RW 02 No 15 Kel. Pejuang
                          Kec. Medan Satria Bekasi, Jawa Barat
                        </p>
                        <p className="card-text">
                          <i className="fa fa-phone-alt text-primary me-2" />
                          <a
                            href="https://wa.me/081546781580"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Chat ke Whatsapp (H. A. Khaidir)
                          </a>
                        </p>
                        {/* Google Map Image */}
                        <iframe
                          className="w-100"
                          height="200"
                          src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Jl.%20Kaliabang%20Bungur%20RT.%2004%20RW%2002%20No%2015%20Kel.%20Pejuang%20Kec.%20Medan%20Satria%20Bekasi%2C%20Jawa%20Barat&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Cabang Perwakilan Subang*/}
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card shadow-sm border-light rounded stabilo1">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: 'black' }}>
                          Perwakilan Subang
                        </h5>
                        <p className="card-text">
                          <i className="fa fa-map-marker-alt text-primary me-2" />
                          Dusun Bangsal RT 001 RW 003 Desa Ciasem Hilir Kec.
                          Ciasem Kab. Subang Jawa Barat
                        </p>
                        <p className="card-text">
                          <i className="fa fa-phone-alt text-primary me-2" />
                          <a
                            href="https://wa.me/081214104527"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Chat ke Whatsapp (Zaenal Luthfi)
                          </a>
                        </p>
                        {/* Google Map Image */}
                        <iframe
                          className="w-100"
                          height="200"
                          src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Dusun%20Bangsal%20RT%20001%20RW%20003%20Desa%20Ciasem%20Hilir%20Kec.%20Ciasem%20Kab.%20Subang%20Jawa%20Barat&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Cabang Perwakilan Garut*/}
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card shadow-sm border-light rounded stabilo1">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: 'black' }}>
                          Perwakilan Garut
                        </h5>
                        <p className="card-text">
                          <i className="fa fa-map-marker-alt text-primary me-2" />
                          Kp. Sayuran RT 001 RW 009 Desa Barusuda Kec. Cigedug
                          Kab. Garut Jawa Barat
                        </p>
                        <p className="card-text">
                          <i className="fa fa-phone-alt text-primary me-2" />
                          <a
                            href="https://wa.me/083825719143"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Chat ke Whatsapp (H. Muhammad Hasanudin)
                          </a>
                        </p>
                        {/* Google Map Image */}
                        <iframe
                          className="w-100"
                          height="200"
                          src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Kp.%20Sayuran%20RT%20001%20RW%20009%20Desa%20Barusuda%20Kec.%20Cigedug%20Kab.%20Garut%20&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}

      {/* Contact End */}
    </div>
  );
}

export default Contact;
